/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IEditProps } from '../../utilities';
import { IDictionary } from '../types';
import { IImageSettings } from './IImageSettings';

export enum ImageFetchPriority {
    High = 'high',
    Low = 'low',
    Auto = 'auto'
}

export interface IImageData {
    /* property to be edited, used to make image editable in site builder */
    editProps?: IEditProps;

    /* Image url */
    src?: string;

    /* Fallback Image url */
    fallBackSrc?: string;

    /* Alt text for image */
    altText?: string;

    /* Image caption */
    caption?: string;

    /* Image tittle */
    title?: string;

    /* Image width */
    width?: number;

    /* Image height */
    height?: number;

    /* Image Settings */
    imageSettings?: IImageSettings;
    /* dictionary with additional misc.  properties*/
    additionalProperties?: IDictionary<string>;

    /* URL */
    href?: string;

    /* External Provider */
    externalProvider?: string;

    /* Defines the hint given to browser on how it should prioritize the fetch of the image relative to other image.  */
    fetchPriority?: ImageFetchPriority;
}
